export default {

  install (Vue) {
    Vue.prototype.$mapType = {
      SI_DO: 'sidoYn',
      SI_GUN_GU: 'sigunguYn',
      POSITION: 'positionYn',
      COMPARE: 'compareYn'
    }

    Vue.prototype.$eventType = {
      CHANGE_MAP_OPTION: 'changeMapOption',
      ADD_YEAR: 'EVENT_ADD_YEAR'
    }

    Vue.prototype.$eventView = {
      SHOW_MAP_OPTIONS_VIEW: 'SHOW_MAP_OPTIONS_VIEW'
    }
  }
}
